var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { ref: "headerScope", class: _vm.classList },
    [
      _c(
        "v-row",
        {
          staticClass: "header__top-row",
          attrs: { variant: "flex", vertical: "center" }
        },
        [
          _c("v-column", { attrs: { tiny: 12 } }, [
            _c(
              "div",
              { staticClass: "header__inner" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "header__logo",
                    attrs: { to: _vm.path("index") }
                  },
                  [
                    _vm.isMenuOpened
                      ? [
                          _c("v-icon", {
                            attrs: {
                              name:
                                "logo/" +
                                (_vm.headerStyle
                                  ? _vm.headerStyle
                                  : "white-blue")
                            }
                          })
                        ]
                      : [
                          _c("v-icon", {
                            attrs: {
                              name:
                                "logo/" +
                                (_vm.headerStyle ? _vm.headerStyle : "blue")
                            }
                          })
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { ref: "headerNav", staticClass: "header__nav" }, [
                  _c(
                    "div",
                    { staticClass: "header__nav-inner" },
                    [
                      _vm._l(_vm.links, function(link, linkIndex) {
                        return !(_vm.isMenuOpened && link.id === "cards")
                          ? _c(
                              "router-link",
                              {
                                key: "menu-link-" + linkIndex,
                                staticClass: "header__link",
                                attrs: {
                                  to: link.query
                                    ? { query: { modal: link.query.modal } }
                                    : _vm.path("" + link.path),
                                  "data-hovered": "true"
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("routes." + link.path + ".label")
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            )
                          : [
                              _c(
                                "ul",
                                { staticClass: "header__list" },
                                _vm._l(_vm.cards, function(item, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: "header-card--item--" + index,
                                      class: "logo-small logo-small--" + item
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "header__link header__list-card",
                                          attrs: {
                                            to: _vm.path(
                                              "orka" + _vm.uCFirst(item)
                                            )
                                          }
                                        },
                                        [
                                          _c("v-image", {
                                            staticClass: "header__list-image",
                                            attrs: {
                                              alt: "orka-" + item,
                                              "aspect-ratio": 23 / 20,
                                              tiny: {
                                                default: require("@/images/logos/small/small-" +
                                                  item +
                                                  ".png"),
                                                retina: require("@/images/logos/small/small-" +
                                                  item +
                                                  "@2.png")
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$t(
                                                  "routes.cards." +
                                                    item +
                                                    ".label"
                                                )
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t"
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            ]
                      }),
                      _vm._v(" "),
                      !_vm.activeModal !== _vm.appModalName
                        ? _c(
                            "v-button",
                            {
                              staticClass: "header__get-app",
                              attrs: {
                                size: !_vm.isMenuOpened ? "small" : null,
                                to: {
                                  query: {
                                    modal: _vm.appModalName
                                  },
                                  params: {
                                    card: _vm.cardType
                                  }
                                },
                                variant: _vm.isMenuOpened
                                  ? "primary"
                                  : _vm.buttonVariant,
                                element: "button"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("button.getApp")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "header__trigger" }, [
                  _c(
                    "div",
                    {
                      class: [
                        "hamburger",
                        {
                          "hamburger--active": _vm.isMenuOpened
                        }
                      ],
                      on: { click: _vm.handleMenu }
                    },
                    [_c("div", { staticClass: "hamburger__item" })]
                  )
                ])
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }